import React, { useState } from "react";
import '../Styles/CreateAccount.scss';
import InputValidation from "../Helper/InputValidation";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

function CreateAccount({ accountInformation, setAccountInformation, page1Next, setPage1Next, handleSubmit }) {

   const [registerError, setRegisterError] = useState('')
   const [emptyEmailError, setEmptyEmailError] = useState(false)
   const [emptyPasswordError, setEmptyPasswordError] = useState(false)
   const [emptyPasswordConfirmError, setEmptyPasswordConfirmError] = useState(false)
   const [showPassword, setShowPassword] = useState(false)
   const [showConfirmPassword, setShowConfirmPassword] = useState(false)
   // The account-creation request chains a check, a registration and a login — it can lag for a
   // few seconds with nothing on screen to show it's working.
   const [isSubmitting, setIsSubmitting] = useState(false)
   const [emptyFirstNameError, setEmptyFirstNameError] = useState(false)
   const [emptyLastNameError, setEmptyLastNameError] = useState(false)
   const [emptyDateOfBirthError, setEmptyDateOfBirthError] = useState(false)
   const [emptyGenderError, setEmptyGenderError] = useState(false)
   const [emptyAddressLineOneError, setEmptyAddressLineOneError] = useState(false)
   const [emptyCityError, setEmptyCityError] = useState(false)
   const [emptyStateError, setEmptyStateError] = useState(false)
   const [emptyZipError, setEmptyZipError] = useState(false)
   const [invalidZipError, setInvalidZipError] = useState(false)
   const [emptyCountryError, setEmptyCountryError] = useState(false)
   const [emptyPhoneError, setEmptyPhoneError] = useState(false)
   const [invalidPhoneError, setInvalidPhoneError] = useState(false)

   function validateAccount() {
      let isError = false

      if (accountInformation.email === "") {
         setEmptyEmailError(true)
         isError = true
      }

      if (accountInformation.password === "") {
         setEmptyPasswordError(true)
         isError = true
      }

      if (accountInformation.confirmPassword === "") {
         setEmptyPasswordConfirmError(true)
         isError = true
      }

      if (accountInformation.firstName === "") {
         setEmptyFirstNameError(true)
         isError = true
      }

      if (accountInformation.lastName === "") {
         setEmptyLastNameError(true)
         isError = true
      }

      // if (accountInformation.birthDate === "") {
      //    setEmptyDateOfBirthError(true)
      //    isError = true
      // }

      if (accountInformation.gender === "") {
         setEmptyGenderError(true)
         isError = true
      }

      if (accountInformation.addressLineOne === "") {
         setEmptyAddressLineOneError(true)
         isError = true
      }

      if (accountInformation.city === "") {
         setEmptyCityError(true)
         isError = true
      }

      if (accountInformation.state === "") {
         setEmptyStateError(true)
         isError = true
      }

      if (accountInformation.zip === "") {
         setEmptyZipError(true)
         isError = true
      }

      if (accountInformation.zip != "") {
         const condition = /^(?!00000)\d{5}(?:[-\s](?!0000)\d{4})?$/
         if (condition.test(accountInformation.zip) === false) {
            setInvalidZipError(true)
            isError = true
         }
      }

      // if (accountInformation.country === "") {
      //    setEmptyCountryError(true)
      //    isError = true
      // }

      if (accountInformation.phone === "") {
         setEmptyPhoneError(true)
         isError = true
      }

      if (accountInformation.phone != "") {
         const condition = /^\d{3}[ -]?\d{3}[ -]?\d{4}$/
         if (condition.test(accountInformation.phone) === false) {
            setInvalidPhoneError(true)
            isError = true
         }
      }

      if (isError == false) 
      {
         handleAccount()
      }
   }
   const handleAccount = async () => {
      setIsSubmitting(true)
      try {
         if (accountInformation.password !== accountInformation.confirmPassword) {
            throw new Error("The passwords entered must match.")
         }

         const apiResponse = await fetch('/api/checkaccount', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               email: accountInformation.email,
               password: accountInformation.password
            })
         })

         const checkAccountResult = await apiResponse.json();

         if (apiResponse.status === 400 || apiResponse.status === 500) {
            throw new Error(checkAccountResult.errors[0].msg);
         }

         await handleSubmit();

      } catch (error) {
         setRegisterError(error.message);
      } finally {
         setIsSubmitting(false)
      }
   }

   const onChange = (event) => {
      setAccountInformation({ ...accountInformation, [event.target.name]: event.target.value })
   }

   return (
      <div className="createAccountContent">
         <div className="createAccountContainer">
            <div className="createAccountHeading">
               Create Account
            </div>
            <div className="createAccountInformation">
               <div className="createAccountCredentials">
                  <div className="createAccountCredentialsHeading">
                     Login Credentials
                  </div>
                  <div className="createAccountCredentialsFields">
                     <div className="createAccountEmail">
                        {emptyEmailError === true &&
                           <div className="emptyEmail">
                              * Email Address Is Required
                           </div>
                        }
                        <label className="firstName">Email</label>
                        <input
                           type="email"
                           name="email"
                           placeholder="email@gmail.com"
                           onChange={(event) => {
                              setAccountInformation({ ...accountInformation, email: event.target.value })
                              setEmptyEmailError(false)
                           }}
                        >
                        </input>
                     </div>
                     <div className="createAccountPassword">
                        {emptyPasswordError === true &&
                           <div className="emptyPassword">
                              * Password Is Required
                           </div>
                        }
                        <label className="firstName">Password</label>
                        <div className="createAccountPasswordWrapper">
                           <input
                              type={showPassword ? "text" : "password"}
                              name="password"
                              placeholder="Password"
                              onChange={(event) => {
                                 setAccountInformation({ ...accountInformation, password: event.target.value })
                                 setEmptyPasswordError(false)
                                 setRegisterError(false)
                              }}
                           >
                           </input>
                           <button
                              type="button"
                              className="createAccountPasswordToggle"
                              onClick={() => setShowPassword(!showPassword)}
                              aria-label={showPassword ? "Hide password" : "Show password"}>
                              {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                           </button>
                        </div>
                     </div>
                     <div className="createAccountPasswordConfirm">
                        {emptyPasswordConfirmError === true &&
                           <div className="emptyPasswordConfirm">
                              * Confirm Password Is Required
                           </div>
                        }
                        <label className="firstName">Confirm Password</label>
                        <div className="createAccountPasswordWrapper">
                           <input
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirmPassword"
                              placeholder="Password"
                              onChange={(event) => {
                                 setAccountInformation({ ...accountInformation, confirmPassword: event.target.value })
                                 setEmptyPasswordConfirmError(false)
                                 setRegisterError(false)
                              }}
                           >
                           </input>
                           <button
                              type="button"
                              className="createAccountPasswordToggle"
                              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                              aria-label={showConfirmPassword ? "Hide password" : "Show password"}>
                              {showConfirmPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                           </button>
                        </div>
                     </div>

                     <div className="disclaimerPSI">
                        <>Password must be: <br></br>
                           - at least 8 characters long;<br></br> - contain one number;<br></br>
                           - contain one symbol;<br></br> - contain one uppercase letter;<br></br>
                           - contain one lowercase letter </>
                     </div>

                  </div>
               </div>
               <div className="createAccountPersonalInformation">
                  <div className="createAccountPersonalInformationHeading">
                     Personal Information
                  </div>
                  <div className="createAccountPersonalInformationFields">
                     <div className="createAccountPersonalInformationFieldsFirstLast">
                        <div className="createAccountPersonalInformationFieldsFirst">
                           {emptyFirstNameError === true &&
                              <div className="emptyFirstName">
                                 * First Name Is Required
                              </div>
                           }
                           <label className="firstName">First Name</label>
                           <input
                              type="text"
                              name="accountHolderFirstName"
                              value={accountInformation.firstName}
                              onChange={(event) => {
                                 setAccountInformation({ ...accountInformation, firstName: event.target.value })
                                 setEmptyFirstNameError(false)
                              }}
                           >
                           </input>
                        </div>
                        <div className="createAccountPersonalInformationFieldsLast">
                           {emptyLastNameError === true &&
                              <div className="emptyLastName">
                                 * Last Name Is Required
                              </div>
                           }
                           <label className="lastName">LastName</label>
                           <input
                              type="text"
                              name="accountHolderFirstName"
                              value={accountInformation.lastName}
                              onChange={(event) => {
                                 setAccountInformation({ ...accountInformation, lastName: event.target.value })
                                 setEmptyLastNameError(false)
                              }}
                           >
                           </input>
                        </div>
                     </div>
                     <div className="createAccountPersonalInformationFieldsBirthdateGender">
                        <div className="createAccountPersonalInformationFieldsBirthdate">
                           {emptyDateOfBirthError === true &&
                              <div className="emptyBirthDate">
                                 * Birth Date Is Required
                              </div>
                           }
                           <label className="firstName">Date of Birth</label>
                           <input
                              type="date"
                              name="accountHolderFirstName"
                              onChange={(event) => {
                                 setAccountInformation({ ...accountInformation, birthDate: event.target.value })
                                 setEmptyDateOfBirthError(false)
                              }}
                           >
                           </input>
                        </div>
                        <div className="createAccountPersonalInformationFieldsGender">
                           {emptyGenderError === true &&
                              <div className="emptyGender">
                                 * Gender Is Required
                              </div>
                           }
                           <label className="firstName">Gender</label>
                           <select
                              value={accountInformation.gender}
                              defaultValue={accountInformation.gender}
                              onChange={event => {
                                 setAccountInformation({ ...accountInformation, gender: (event.target.value) })
                                 setEmptyGenderError(false)
                              }}
                              id="state"
                              name="state">
                              <option value="Select">Select</option>
                              <option value="M">Male</option>
                              <option value="F">Female</option>
                           </select>

                        </div>
                     </div>
                  </div>
               </div>
               <div className="createAccountContactInformation">
                  <div className="createAccountContactInformationHeading">
                     Contact Information
                  </div>
                  <div className="createAccountContactInformationFields">
                     <div className="createAccountContactInformationFieldsAddress">
                        <div className="createAccountContactInformationFieldsAddressOne">
                           {emptyAddressLineOneError === true &&
                              <div className="emptyAddressLineOne">
                                 * Address Line One Is Required
                              </div>
                           }
                           <label className="firstName">Address Line One</label>
                           <input
                              type="text"
                              name="accountHolderFirstName"
                              value={accountInformation.addressLineOne}
                              onChange={(event) => {
                                 setAccountInformation({ ...accountInformation, addressLineOne: event.target.value })
                                 setEmptyAddressLineOneError(false)
                              }}
                           >
                           </input>
                        </div>
                        <div className="createAccountContactInformationFieldsAddressTwo">
                           <label className="firstName">Address Line Two</label>
                           <input
                              type="text"
                              name="accountHolderFirstName"
                              value={accountInformation.addressLineTwo}
                              onChange={(event) => setAccountInformation({ ...accountInformation, addressLineTwo: event.target.value })}
                           >
                           </input>
                        </div>
                     </div>
                     <div className="createAccountContactInformationFieldsCityStateZip">
                        <div className="createAccountContactInformationFieldsCity">
                           {emptyCityError === true &&
                              <div className="emptyCity">
                                 * City Is Required
                              </div>
                           }
                           <label>City </label>
                           <input
                              type="text"
                              required
                              value={accountInformation.city}
                              onChange={(e) => {
                                 setAccountInformation({ ...accountInformation, city: (e.target.value) })
                                 setEmptyCityError(false)
                              }}
                           />
                        </div>
                        <div className="createAccountContactInformationFieldsState">
                           {emptyStateError === true &&
                              <div className="emptyState">
                                 * State Is Required
                              </div>
                           }
                           <label for="state">State </label>
                           <select
                              value={accountInformation.state}
                              defaultValue={accountInformation.state}
                              onChange={event => {
                                 setAccountInformation({ ...accountInformation, state: (event.target.value) })
                                 setEmptyStateError(false)
                              }}
                              id="state"
                              name="state">
                              <option value="---">---</option>
                              <option value="Alabama">Alabama</option>
                              <option value="Alaska">Alaska</option>
                              <option value="Arizona">Arizona</option>
                              <option value="Arkansas">Arkansas</option>
                              <option value="California">California</option>
                              <option value="Colorado">Colorado</option>
                              <option value="Connecticut">Connecticut</option>
                              <option value="Delaware">Delaware</option>
                              <option value="District of Columbia">District of Columbia</option>
                              <option value="Florida">Florida</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Guam">Guam</option>
                              <option value="Hawaii">Hawaii</option>
                              <option value="Idaho">Idaho</option>
                              <option value="Illinois">Illinois</option>
                              <option value="Indiana">Indiana</option>
                              <option value="Iowa">Iowa</option>
                              <option value="Kansas">Kansas</option>
                              <option value="Kentucky">Kentucky</option>
                              <option value="Louisiana">Louisiana</option>
                              <option value="Maine">Maine</option>
                              <option value="Maryland">Maryland</option>
                              <option value="Massachusetts">Massachusetts</option>
                              <option value="Michigan">Michigan</option>
                              <option value="Minnesota">Minnesota</option>
                              <option value="Mississippi">Mississippi</option>
                              <option value="Missouri">Missouri</option>
                              <option value="Montana">Montana</option>
                              <option value="Nebraska">Nebraska</option>
                              <option value="Nevada">Nevada</option>
                              <option value="New Hampshire">New Hampshire</option>
                              <option value="New Jersey">New Jersey</option>
                              <option value="New Mexico">New Mexico</option>
                              <option value="New York">New York</option>
                              <option value="North Carolina">North Carolina</option>
                              <option value="North Dakota">North Dakota</option>
                              <option value="Northern Marianas Islands">Northern Marianas Islands</option>
                              <option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option>
                              <option value="Oregon">Oregon</option>
                              <option value="Pennsylvania">Pennsylvania</option>
                              <option value="Puerto Rico">Puerto Rico</option>
                              <option value="Rhode Island">Rhode Island</option>
                              <option value="South Carolina">South Carolina</option>
                              <option value="South Dakota">South Dakota</option>
                              <option value="Tennessee">Tennessee</option>
                              <option value="Texas">Texas</option>
                              <option value="Utah">Utah</option>
                              <option value="Vermont">Vermont</option>
                              <option value="Virginia">Virginia</option>
                              <option value="Virgin Islands">Virgin Islands</option>
                              <option value="Washington">Washington</option>
                              <option value="West Virginia">West Virginia</option>
                              <option value="Wisconsin">Wisconsin</option>
                              <option value="Wyoming">Wyoming</option>
                           </select>
                        </div>
                        <div className="createAccountContactInformationFieldsZip">
                           {emptyZipError === true &&
                              <div className="emptyZip">
                                 * Zip Is Required
                              </div>
                           }
                           {invalidZipError === true &&
                              <div className="InvalidZip">
                                 * Zip code must be formatted as such: 12345, 12345 6789, or 12345-6789
                              </div>
                           }
                           <label>Zip:* </label>
                           <input
                              type="text"
                              required
                              maxLength={10}
                              value={accountInformation.zip}
                              onChange={(e) => {
                                 setAccountInformation({ ...accountInformation, zip: InputValidation.ValidateInputForPhoneAndZipCode(e.target.value) })
                                 setInvalidZipError(false)
                                 setEmptyZipError(false)
                              }} />
                        </div>
                     </div>
                     <div className="createAccountContactInformationFieldsCountryPhone">
                        <div className="createAccountContactInformationFieldsCountry">
                           {emptyCountryError === true &&
                              <div className="emptyCountry">
                                 * Country Is Required
                              </div>
                           }
                           <label for="state">Country </label>
                           <select
                              value={accountInformation.country}
                              defaultValue={accountInformation.country}
                              onChange={event => {
                                 setAccountInformation({ ...accountInformation, country: (event.target.value) })
                                 setEmptyCountryError(false)
                              }}
                              id="state"
                              name="state">
                              <option value="Select Country">Select Country</option>
                              <option value="Afghanistan">Afghanistan</option>
                              <option value="Albania">Albania</option>
                              <option value="Algeria">Algeria</option>
                              <option value="Andorra">Andorra</option>
                              <option value="Angola">Angola</option>
                              <option value="AntiguaAndBarbuda">Antigua and Barbuda</option>
                              <option value="Argentina">Argentina</option>
                              <option value="Armenia">Armenia</option>
                              <option value="Australia">Australia</option>
                              <option value="Austria">Austria</option>
                              <option value="Azerbaijan">Azerbaijan</option>
                              <option value="Bahamas">Bahamas</option>
                              <option value="Bahrain">Bahrain</option>
                              <option value="Bangladesh">Bangladesh</option>
                              <option value="Barbados">Barbados</option>
                              <option value="Belarus">Belarus</option>
                              <option value="Belgium">Belgium</option>
                              <option value="Belize">Belize</option>
                              <option value="Benin">Benin</option>
                              <option value="Bhutan">Bhutan</option>
                              <option value="Bolivia">Bolivia</option>
                              <option value="BosniaAndHerzegovina">Bosnia and Herzegovina</option>
                              <option value="Botswana">Botswana</option>
                              <option value="Brazil">Brazil</option>
                              <option value="BruneiDarussalam">Brunei Darussalam</option>
                              <option value="Bulgaria">Bulgaria</option>
                              <option value="BurkinaFaso">Burkina Faso</option>
                              <option value="Burundi">Burundi</option>
                              <option value="CaboVerde">Cabo Verde</option>
                              <option value="Cambodia">Cambodia</option>
                              <option value="Cameroon">Cameroon</option>
                              <option value="Canada">Canada</option>
                              <option value="CentralAfricanRepublic">Central African Republic</option>
                              <option value="Chad">Chad</option>
                              <option value="Chile">Chile</option>
                              <option value="China">China</option>
                              <option value="Colombia">Colombia</option>
                              <option value="Comoros">Comoros</option>
                              <option value="Congo">Congo</option>
                              <option value="CongoDemocraticRepublic">Congo, Democratic Republic of the</option>
                              <option value="CostaRica">Costa Rica</option>
                              <option value="Croatia">Croatia</option>
                              <option value="Cuba">Cuba</option>
                              <option value="Cyprus">Cyprus</option>
                              <option value="CzechRepublic">Czech Republic</option>
                              <option value="Denmark">Denmark</option>
                              <option value="Djibouti">Djibouti</option>
                              <option value="Dominica">Dominica</option>
                              <option value="DominicanRepublic">Dominican Republic</option>
                              <option value="Ecuador">Ecuador</option>
                              <option value="Egypt">Egypt</option>
                              <option value="ElSalvador">El Salvador</option>
                              <option value="EquatorialGuinea">Equatorial Guinea</option>
                              <option value="Eritrea">Eritrea</option>
                              <option value="Estonia">Estonia</option>
                              <option value="Eswatini">Eswatini</option>
                              <option value="Ethiopia">Ethiopia</option>
                              <option value="Fiji">Fiji</option>
                              <option value="Finland">Finland</option>
                              <option value="France">France</option>
                              <option value="Gabon">Gabon</option>
                              <option value="Gambia">Gambia</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Germany">Germany</option>
                              <option value="Ghana">Ghana</option>
                              <option value="Greece">Greece</option>
                              <option value="Grenada">Grenada</option>
                              <option value="Guatemala">Guatemala</option>
                              <option value="Guinea">Guinea</option>
                              <option value="GuineaBissau">Guinea-Bissau</option>
                              <option value="Guyana">Guyana</option>
                              <option value="Haiti">Haiti</option>
                              <option value="Honduras">Honduras</option>
                              <option value="Hungary">Hungary</option>
                              <option value="Iceland">Iceland</option>
                              <option value="India">India</option>
                              <option value="Indonesia">Indonesia</option>
                              <option value="Iran">Iran</option>
                              <option value="Iraq">Iraq</option>
                              <option value="Ireland">Ireland</option>
                              <option value="Israel">Israel</option>
                              <option value="Italy">Italy</option>
                              <option value="Jamaica">Jamaica</option>
                              <option value="Japan">Japan</option>
                              <option value="Jordan">Jordan</option>
                              <option value="Kazakhstan">Kazakhstan</option>
                              <option value="Kenya">Kenya</option>
                              <option value="Kiribati">Kiribati</option>
                              <option value="KoreaDemocraticPeopleRepublic">Korea, Democratic People's Republic of</option>
                              <option value="KoreaRepublic">Korea, Republic of</option>
                              <option value="Kuwait">Kuwait</option>
                              <option value="Kyrgyzstan">Kyrgyzstan</option>
                              <option value="LaoPeoplesDemocraticRepublic">Lao People's Democratic Republic</option>
                              <option value="Latvia">Latvia</option>
                              <option value="Lebanon">Lebanon</option>
                              <option value="Lesotho">Lesotho</option>
                              <option value="Liberia">Liberia</option>
                              <option value="Libya">Libya</option>
                              <option value="Liechtenstein">Liechtenstein</option>
                              <option value="Lithuania">Lithuania</option>
                              <option value="Luxembourg">Luxembourg</option>
                              <option value="Madagascar">Madagascar</option>
                              <option value="Malawi">Malawi</option>
                              <option value="Malaysia">Malaysia</option>
                              <option value="Maldives">Maldives</option>
                              <option value="Mali">Mali</option>
                              <option value="Malta">Malta</option>
                              <option value="MarshallIslands">Marshall Islands</option>
                              <option value="Mauritania">Mauritania</option>
                              <option value="Mauritius">Mauritius</option>
                              <option value="Mexico">Mexico</option>
                              <option value="Micronesia">Micronesia</option>
                              <option value="Moldova">Moldova</option>
                              <option value="Monaco">Monaco</option>
                              <option value="Mongolia">Mongolia</option>
                              <option value="Montenegro">Montenegro</option>
                              <option value="Morocco">Morocco</option>
                              <option value="Mozambique">Mozambique</option>
                              <option value="Myanmar">Myanmar</option>
                              <option value="Namibia">Namibia</option>
                              <option value="Nauru">Nauru</option>
                              <option value="Nepal">Nepal</option>
                              <option value="Netherlands">Netherlands</option>
                              <option value="NewZealand">New Zealand</option>
                              <option value="Nicaragua">Nicaragua</option>
                              <option value="Niger">Niger</option>
                              <option value="Nigeria">Nigeria</option>
                              <option value="NorthMacedonia">North Macedonia</option>
                              <option value="Norway">Norway</option>
                              <option value="Oman">Oman</option>
                              <option value="Pakistan">Pakistan</option>
                              <option value="Palau">Palau</option>
                              <option value="Panama">Panama</option>
                              <option value="PapuaNewGuinea">Papua New Guinea</option>
                              <option value="Paraguay">Paraguay</option>
                              <option value="Peru">Peru</option>
                              <option value="Philippines">Philippines</option>
                              <option value="Poland">Poland</option>
                              <option value="Portugal">Portugal</option>
                              <option value="Qatar">Qatar</option>
                              <option value="Romania">Romania</option>
                              <option value="RussianFederation">Russian Federation</option>
                              <option value="Rwanda">Rwanda</option>
                              <option value="SaintKittsAndNevis">Saint Kitts and Nevis</option>
                              <option value="SaintLucia">Saint Lucia</option>
                              <option value="SaintVincentAndTheGrenadines">Saint Vincent and the Grenadines</option>
                              <option value="Samoa">Samoa</option>
                              <option value="SanMarino">San Marino</option>
                              <option value="SaoTomeAndPrincipe">Sao Tome and Principe</option>
                              <option value="SaudiArabia">Saudi Arabia</option>
                              <option value="Senegal">Senegal</option>
                              <option value="Serbia">Serbia</option>
                              <option value="Seychelles">Seychelles</option>
                              <option value="SierraLeone">Sierra Leone</option>
                              <option value="Singapore">Singapore</option>
                              <option value="Slovakia">Slovakia</option>
                              <option value="Slovenia">Slovenia</option>
                              <option value="SolomonIslands">Solomon Islands</option>
                              <option value="Somalia">Somalia</option>
                              <option value="SouthAfrica">South Africa</option>
                              <option value="SouthSudan">South Sudan</option>
                              <option value="Spain">Spain</option>
                              <option value="SriLanka">Sri Lanka</option>
                              <option value="Sudan">Sudan</option>
                              <option value="Suriname">Suriname</option>
                              <option value="Sweden">Sweden</option>
                              <option value="Switzerland">Switzerland</option>
                              <option value="Syria">Syria</option>
                              <option value="Taiwan">Taiwan</option>
                              <option value="Tajikistan">Tajikistan</option>
                              <option value="Tanzania">Tanzania</option>
                              <option value="Thailand">Thailand</option>
                              <option value="TimorLeste">Timor-Leste</option>
                              <option value="Togo">Togo</option>
                              <option value="Tonga">Tonga</option>
                              <option value="TrinidadAndTobago">Trinidad and Tobago</option>
                              <option value="Tunisia">Tunisia</option>
                              <option value="Turkey">Turkey</option>
                              <option value="Turkmenistan">Turkmenistan</option>
                              <option value="Tuvalu">Tuvalu</option>
                              <option value="Uganda">Uganda</option>
                              <option value="Ukraine">Ukraine</option>
                              <option value="UnitedArabEmirates">United Arab Emirates</option>
                              <option value="UnitedKingdom">United Kingdom</option>
                              <option value="UnitedStates">United States</option>
                              <option value="Uruguay">Uruguay</option>
                              <option value="Uzbekistan">Uzbekistan</option>
                              <option value="Vanuatu">Vanuatu</option>
                              <option value="Venezuela">Venezuela</option>
                              <option value="Vietnam">Vietnam</option>
                              <option value="Yemen">Yemen</option>
                              <option value="Zambia">Zambia</option>
                              <option value="Zimbabwe">Zimbabwe</option>
                           </select>
                        </div>
                        <div className="createAccountContactInformationFieldsPhone">
                           {emptyPhoneError === true &&
                              <div className="emptyPhone">
                                 * Phone Is Required
                              </div>
                           }
                           {invalidPhoneError === true &&
                              <div className="InvalidPhone">
                                 * Phone number must be formatted as such: 1234567890, 123 456 7890, or 123-456-7890
                              </div>
                           }
                           <label>Phone </label>
                           <input
                              type="tel"
                              required
                              maxLength={14}
                              value={accountInformation.phone}
                              onChange={(event) => {
                                 setAccountInformation({ ...accountInformation, phone: (event.target.value) })
                                 setEmptyPhoneError(false)
                                 setInvalidPhoneError(false)
                              }} />
                        </div>
                     </div>
                  </div>

               </div>


               <div className="disclaimerCA">
                  <>* Fields are required</>
               </div>

               <div style={{ color: 'red', margin: '10px, 0', fontFamily: 'Sen' }}>{registerError}</div>
               <div style={{ color: 'green', margin: '10px, 0', fontFamily: 'Sen' }}>{ }</div>
               <div className="buttonCreateAccount">
                  <button className="nextButton" disabled={isSubmitting} onClick={() => validateAccount()}>
                     {isSubmitting && <span className="authSpinner" aria-hidden="true"></span>}
                     {isSubmitting ? "Creating Account..." : "Create"}
                  </button>
               </div>
            </div>
         </div>

      </div>
   )
}

export default CreateAccount;